

































import { Component, Vue, Watch } from 'vue-property-decorator'
import { membershipState } from '../../store/modules/MembershipState'
import {
  getUserInfo,
  loginCheck,
  SapLoginInfo,
  ssoLogin
} from '../../modules/util/SapUtil'
import RegisteredUserInfo from '../../modules/class/RegisteredUserInfo'
import {
  fillForm,
  checkForm,
  addOpenAccordionEvent
} from '../../modules/util/WebformElement'
import LoadingAnimation from '../../components/Parts/LoadingAnimation.vue'

@Component({
  components: {
    LoadingAnimation
  }
})
export default class LoginCheckPage extends Vue {
  private readonly vueid = 'vue_login_check_page'

  private showModal = false

  // -------------------------------------------------------------------------------------------------------------------
  // Props
  get isLogin(): boolean {
    return membershipState.isLogin
  }

  get isDrupalLogin(): boolean {
    return drupalSettings.vueComponent.common.isDrupalLogin ?? false
  }

  get userInfo(): RegisteredUserInfo {
    return membershipState.userInfo
  }

  get sapLoginInfo(): SapLoginInfo {
    return membershipState.sapLoginInfo
  }

  // ------------------------------------------------------------------------------------------------
  // hooks
  private created() {
    // アコーディオンを開かせるイベントを追加
    addOpenAccordionEvent()
  }

  private async mounted() {
    // ログイン状態に応じてモーダルを表示する
    loginCheck(
      () => {
        getUserInfo()
        this.showModal = false
      },
      () => {
        this.showModal = true
      }
    )
  }

  // -------------------------------------------------------------------------------------------------------------------
  // methods

  /**
   * 会員情報を埋める
   */
  private async fillUserInfo() {
    // フォーム項目に代入
    fillForm('#edit-user-id', this.sapLoginInfo.UID, true)
    fillForm('#edit-first-name', this.userInfo.firstname, true)
    fillForm('#edit-last-name', this.userInfo.lastname, true)
    fillForm('#edit-email-address', this.userInfo.email, true)
    fillForm('#edit-organization', this.userInfo.organization, false)
    fillForm('#edit-job-role', this.userInfo.jobRoles, false)
    fillForm('#edit-country-region', this.userInfo.countryRegion, false)
    fillForm('#edit-address', this.userInfo.address, false)
    fillForm('#edit-city', this.userInfo.city, false)
    fillForm('#edit-state', this.userInfo.state, false)
    fillForm('#edit-zip-postal-code', this.userInfo.zipCode, false)
    fillForm('#edit-phone', this.userInfo.phone, false)
    fillForm('#edit-mobile-phone', this.userInfo.mobilePhone, false)
    fillForm('#edit-department', this.userInfo.department, false)
    checkForm(
      '#edit-email-subscription',
      this.userInfo.emailSubscription,
      false,
      false
    )
  }

  /**
   * ログイン画面に遷移する
   */
  private signIn() {
    if (!this.isLogin) {
      ssoLogin(window.location.href, 'gigya-login-screen')
    }
  }

  @Watch('isLogin')
  onIsLoginChanged(): void {
    if (this.isLogin) {
      getUserInfo()
      this.showModal = false
    } else {
      this.showModal = true
    }
  }

  @Watch('userInfo', { deep: true })
  onChangeUserInfo(): void {
    if (this.userInfo.email !== '') {
      this.fillUserInfo()
    }
  }
}
